<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <v-app-bar app class="elevation-1 grey lighten-3" clipped-left dense>
    <!--    This block adds condinitonal images when whitelabling clients. -->

    <v-img
      contain
      max-height="100"
      max-width="75"
      @click="update_results_cube"
      :src="
        require('../../assets/img/application/' +
          this.$store.state.user.userServerInfo.user.fields.institution[0].fields
            .application_image)
      "
    ></v-img>
    <span class="caption d-none d-md-flex ml-4 " @click="load_state">
      {{
        $store.state.user.userServerInfo.user.fields.institution[0].fields
          .institution_name
      }}
    </span>

    <template
      v-if="
        (user_apps.length > 1 &&
          $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
            .markets_count > 0) ||
          $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
            .products_count > 0
      "
    >
      <template
        v-if="user.fields.user[0] === 'tobie' || user.fields.user[0] === 'martin'"
      >
        <v-tooltip right>
          <template v-slot:activator="{on, attrs}">
            <span v-on="on">
              <v-btn
                text
                x-small
                @click="
                  change_application($store.state.app.available_applications[0].value)
                "
                class="caption ma-0 pa-0"
                :disabled="
                  app.selected_application ===
                    $store.state.app.available_applications[0].value
                "
                >{{ $store.state.app.available_applications[0].text }}
              </v-btn></span
            >
          </template>
          <span>Export Market Finder</span>
        </v-tooltip>

        <v-tooltip right>
          <template v-slot:activator="{on, attrs}">
            <span v-on="on">
              <v-btn
                text
                x-small
                @click="
                  change_application($store.state.app.available_applications[1].value)
                "
                :disabled="
                  app.selected_application ===
                    $store.state.app.available_applications[1].value
                "
                class="caption ma-0 pa-0"
                >{{ $store.state.app.available_applications[1].text }}
              </v-btn>
            </span>
          </template>
          <span>Exporter Engagement Process</span>
        </v-tooltip>
      </template>

      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <span class="caption font-weight-bold grey--text">{{ selected_app_text }}</span>
      <!--      <v-select-->
      <!--        v-if="-->
      <!--          user_app_dropdown_values().length > 1 &&-->
      <!--            $store.state.app.selected_application === 'trade-dsm'-->
      <!--        "-->
      <!--        :items="user_app_dropdown_values()"-->
      <!--        :value="dropdown_values"-->
      <!--        class="caption d-none d-md-flex"-->
      <!--        dense-->
      <!--        eager-->
      <!--        hide-details="true"-->
      <!--        hide-selected-->
      <!--        @change="change_app($event)"-->
      <!--      ></v-select>-->
      <!--      <span v-else class="caption d-none d-md-flex">-->
      <!--        {{ user.fields.institution[0].fields.application_name }} - -->
      <!--        {{ user_app_dropdown_values()[0]['value']['home_market_name'] }}({{-->
      <!--          user_app_dropdown_values()[0]['value']['sub_national_name']-->
      <!--        }})-->
      <!--      </span>-->
    </template>

    <!--    </span>-->

    <v-spacer />
    <v-spacer />
    <v-spacer />
    <v-spacer />
    <v-spacer />
    <v-spacer />

    <v-tooltip bottom>
      <template v-slot:activator="{on}">
        <v-btn v-if="!logged_in" v-on="on" icon>
          <v-icon class="red--text rounded-circle" @click="login_dialog = !login_dialog"
            >mdi-account-alert-outline
          </v-icon>
        </v-btn>
        <v-btn v-else v-on="on" icon>
          <v-icon class="white--text orange rounded-circle " @click="logout_app"
            >mdi-account-check
          </v-icon>
        </v-btn>
      </template>
      <span>{{
        !logged_in
          ? 'Login'
          : `Logout ${$store.state.user.userServerInfo.user.fields.user[0]}`
      }}</span>
    </v-tooltip>

    <v-btn icon>
      <v-icon
        class="white--text orange rounded-circle"
        @click.stop="app.drawerRight = !app.drawerRight"
        >mdi-menu
      </v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex';
import filterHelpers from '@/components/trade-dsm-application/mixins/filter-helpers';
import swal from 'sweetalert';
// import {eventBus} from '@/main';

export default {
  name: 'navigationBar',
  mixins: [filterHelpers],

  computed: {
    ...mapGetters(['get_selected_app_name', 'user_apps', 'logged_in', 'user']),
    ...mapState(['app', 'tradeDSM']),

    selected_app_text() {
      const last_market_model = JSON.parse(localStorage.getItem('last_market_model'));
      return (
        this.user.fields.institution[0].fields.application_name +
        ' : ' +
        last_market_model.home_market_name +
        ' (' +
        last_market_model.sub_national_name +
        ')'
      );
    },
    dropdown_values: function() {
      if (typeof this.user !== 'undefined') {
        return {
          text: this.get_selected_app_name,
          value: {
            home_market_name: this.$store.state.app.selectedHomeCountry,
            home_market_code: this.$store.state.tradeDSM.dsm_filter_setttings.Home_Market,
            sub_national_code: this.$store.state.app.selectedModelVersion,
            sub_national_name: this.$store.state.app.selectedModelName,
            app_name: this.user.fields.institution[0].fields.application_name,
          },
        };
      } else return null;
    },
  },
  methods: {
    ...mapMutations([
      'logout',
      'appSelected',
      'appExpiryDate',
      'setTop6ResultCountries',
      'setDSMFilterForSearch_Product_Top_Filter',
      'setDSMFilterForSearch_Target_Market_Top_Filter',
      'setHomeCountry',
      'setHomeMarket',
      'setModelVersion',
      'setModelName',
      'set_dsm_filters',
      'set_trade_dsm_state',
    ]),

    async change_application(event) {
      console.log(event);
      this.app.selected_application = event;
      await this.$router.push(event);
    },
    async save_state() {
      // const save_name = prompt('Save name?');
      // this.clear_circ_ref_error();
      // await this.$setItem(
      //   save_name,
      //   JSON.parse(
      //     JSON.stringify(this.$store.state.tradeDSM.dsm_filter_setttings.Filters),
      //   ),
      // );
    },
    async load_state() {
      // const save_name = prompt('Load name?');
      // const obj = await this.$getItem(save_name);
      // this.clear_circ_ref_error();
      //
      // await this.set_trade_dsm_state(obj);
      // eventBus.$emit('CLEAR_MARKETS_TOP_LIST');
      // eventBus.$emit('CLEAR_PRODUCTS_TOP_LIST');
      // console.log('restored');
    },

    send_mail() {
      window.open(this.email_text(), '_self');
    },
    email_text() {
      return `mailto:martin.cameron@tradeadvisory.co.za
            ?subject=Email from DSM
            &body=`;
    },
    user_app_dropdown_values: function() {
      if (typeof this.user_apps !== 'undefined' && typeof this.user !== 'undefined') {
        return this.user_apps
          .filter(v => v.active === true)
          .map(v => ({
            text:
              this.user.fields.institution[0].fields.application_name +
              '-' +
              v.subscription.home_market_name +
              '(' +
              v.subscription.sub_national_name +
              ')',
            value: {
              home_market_name: v.subscription.home_market_name,
              home_market_code: v.subscription.home_market_code,
              sub_national_code: v.subscription.sub_national_code,
              sub_national_name: v.subscription.sub_national_name,
              app_name: this.user.fields.institution[0].fields.application_name,
            },
          }));
      } else {
        return [];
      }
    },
    clear_app_data: async function() {
      this.setTop6ResultCountries([]);
      this.setDSMFilterForSearch_Product_Top_Filter('');
      this.setDSMFilterForSearch_Target_Market_Top_Filter('');
      this.tradeDSM.dsm_filter_setttings.Product_Combinations['selection_view'] = '1P1C';
      this.$store.commit('set_list_name_product', '');
      this.$store.commit('set_list_name_country', '');
      this.$store.commit('setDSMFilterForSearch_Product', '');
      this.$store.commit('setDSMFilterForSearch_Product', '');
      this.$store.commit('setDSMFilterForSearch_Target_Market', '');
      this.$store.commit('set_list_manager_selection_country', '');
      this.$store.commit('set_list_manager_selection_product', '');

      this.setHomeCountry('');
      this.setHomeMarket('');
      this.setModelVersion('');
      this.setModelName('');
      // this.$store.state.user.userServerInfo.subscriptions = [];
      this.$store.commit('reset_trade_dsm_app');
      return 'ok';
    },
    logout_app() {
      swal('Confirm Logout', {
        icon: 'info',

        buttons: {
          word: {
            text: 'Yes',
            value: 'yes',
          },
          email: {
            text: 'Cancel',
            value: 'cancel',
          },
        },
      }).then(value => {
        switch (value) {
          case 'yes':
            this.logout();
            this.appSelected('');
            this.appExpiryDate('');

            localStorage.setItem('token', '');
            localStorage.setItem('refresh', '');

            this.clear_app_data();
            // this.$router.push('login');
            // this.$router.push(this.$store.state.app.base_login_page)
            this.$router.push(localStorage.getItem('reload_url'));
            location.reload();
            break;

          case 'cancel':
            break;
        }
      });
    },
    change_app: async function(event) {
      await this.clear_app_data();
      this.appSelected(
        event.app_name +
          '-' +
          event.home_market_name +
          '(' +
          event.sub_national_name +
          ')',
      );
      document.title = this.app.selectedApp;

      this.setHomeCountry(event.home_market_name);
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.home_market =
        event.home_market_code;

      this.setHomeMarket(event.home_market_code);
      this.setModelVersion(event.sub_national_code);
      this.setModelName(event.sub_national_name);

      swal({
        text:
          'Switching Home Market.\n\nPlease be patient. This step can take some time.',
        buttons: false,
        closeOnClickOutside: false,
        icon: 'info',
        className: 'swal-modal',
        closeOnEsc: false,
      });

      await this.load_dsm_filters(
        this.$store.state.tradeDSM.dsm_filter_setttings.Home_Market,
        this.$store.state.app.selectedModelVersion,
        'all',
        'all',
      );
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.load_presets = false;
      await this.run_dsm_advanced_query();
      localStorage.setItem(
        'FILTERS',
        JSON.stringify(this.$store.state.tradeDSM.dsm_filter_setttings.Filters),
      );
      swal.close();

      swal('Please be patient...\n\nPresetting filters', {
        buttons: false,
        icon: 'info',
      });

      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.load_presets = false;

      await this.load_preset();
      swal.close();

      swal('Please be patient...\n\nUpdating filters', {
        buttons: false,
      });
      await this.update_filters_selection();
      swal.close();

      swal('Please be patient...\n\nFinal setup', {
        buttons: false,
      });
      // this.$store.state.tradeDSM.dsm_filter_setttings.Filters['META']['include_product_exclusions'] = true

      await this.run_dsm_advanced_query();
      swal.close();

      localStorage.setItem(
        'FILTERS_PRESET',
        JSON.stringify(this.$store.state.tradeDSM.dsm_filter_setttings.Filters),
      );

      let save_state = {};
      save_state[event.home_market_code] = {};
      save_state[event.home_market_code][event.sub_national_name] = this.$store.state;
      await localStorage.removeItem('MASTER_STATE');
      await localStorage.setItem('MASTER_STATE', JSON.stringify(save_state));

      this.$store.commit('setupdatingMarketProductCombinations', false);
    },
  },
  data: () => ({}),
};
</script>

<style scoped>
.app-bar-color--text {
  color: #1f3c5f;
}

.v-select {
  width: 240px;
}

.v-select:hover {
  background-color: lightgrey;
  transition: background 1s cubic-bezier(0.25, 0.8, 0.5, 1);
  border-radius: 5px;
  padding: 5px;
}
</style>
